import { memo } from 'react'
import { rem } from 'polished'
import ExperiencesPageCategoryTile from './ExperiencesPageCategoryTile'
import { fillArray, take } from 'lib/array/arrayUtils'
import { replaceExperienceQueryString } from 'lib/experiences/experienceUtils'
import { LUX_PLUS_MEMBER_PRICES_FILTER } from 'lib/experiences/luxPlusFeatureFilterUtils'

import ExperiencesPageCategoryTileLoadingSkeleton from './ExperiencesPageCategoryTileLoadingSkeleton'
import type { CategoryData } from '../hooks/useMostPopulatedSearchExperienceFacets'
import useMostPopulatedSearchExperienceFacets from '../hooks/useMostPopulatedSearchExperienceFacets'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { EXP_CATEGORY_LUX_PLUS_ID } from 'constants/experience'

const MAX_DISPLAYED_CATEGORIES = 6

interface Props {
  place: App.Place
}

function ExperiencesPageCategoriesCarousel(props: Props) {
  const { place } = props

  const { primaryCategories, fetching } = useMostPopulatedSearchExperienceFacets(place, {
    useParentCategoryCounts: true,
  })

  const getSearchUrl = (
    place: App.Place,
    categoryData: CategoryData,
  ) => {
    const isLuxPlusCategory = categoryData.parent.id === EXP_CATEGORY_LUX_PLUS_ID
    const query = replaceExperienceQueryString({
      destinationId: place.id,
      destinationName: place.name,
      categories: isLuxPlusCategory ? undefined : [categoryData.parent.id.toString()],
      luxPlusFeatures: isLuxPlusCategory ? [LUX_PLUS_MEMBER_PRICES_FILTER] : undefined,
    })
    return `/search/experiences?${query}`
  }

  if (primaryCategories.length === 0 && !fetching) {
    return null
  }

  return (
    <CardCarousel pageSize={6} width={rem(180)}>
      {fetching && fillArray(MAX_DISPLAYED_CATEGORIES).map((_, index) => <ExperiencesPageCategoryTileLoadingSkeleton key={index} />)}
      {primaryCategories.length > 0 && <>
        {take(primaryCategories, MAX_DISPLAYED_CATEGORIES).map(cat => <ExperiencesPageCategoryTile
          key={cat.parent.id}
          category={cat.parent}
          count={cat.count}
          to={getSearchUrl(place, cat)}
          childCategories={cat.children}
        />)}
      </>}
    </CardCarousel>
  )
}

export default memo(ExperiencesPageCategoriesCarousel)
